// 基隆未來捷運路線資料
// tpemrt-v1: #c48c31
// tpemrt-v2: #e3002c
// tpemrt-v3: #f8b61c
// tpemrt-v4: #008659
// tpemrt-v5: #0070bd
// tpemrt-v6: #8246AF
// tpemrt-v7: #FFDB00
// tpemrt-v8: #e5554f
export const lines = [
  //v1
  {
    name: '基隆捷運第一階段',
    variant: 'tpemrt-v1',
    info: '2024年1月獲行政院核定，規劃於2033年完工通車',
  },
]

export const stations = [
  [
    {
      name: '南陽大橋',
      address: '',
      lat: 25.054993,
      lng: 121.634116,
    },
    {
      name: '樟樹灣 SB13',
      address: '',
      lat: 25.060387,
      lng: 121.640321,
    },
    {
      name: '汐科 SB14',
      address: '',
      lat: 25.063143,
      lng: 121.647152,
    },
    {
      name: '汐止區公所 SB15',
      address: '',
      lat: 25.064883,
      lng: 121.659281,
    },
    {
      name: '保長坑2',
      address: '',
      lat: 25.068066,
      lng: 121.673159,
    },
    {
      name: '南陽大橋',
      address: '',
      lat: 25.054993,
      lng: 121.634116,
    },
    {
      name: '保長坑1',
      address: '',
      lat: 25.071223,
      lng: 121.67852,
    },
    {
      name: '北五堵',
      address: '',
      lat: 25.082272,
      lng: 121.685257,
    },
    {
      name: '百福',
      address: '',
      lat: 25.088206,
      lng: 121.696403,
    },
    {
      name: '六堵',
      address: '',
      lat: 25.094562,
      lng: 121.702013,
    },
    {
      name: '七堵',
      address: '',
      lat: 25.096552,
      lng: 121.71024,
    },
    {
      name: '八堵',
      address: '',
      lat: 25.108167,
      lng: 121.728883,
    },
  ],
]
